import React, {Component} from 'react';

/**
 * HOC for getting the current scroll position
 * @param {Function} WrappedComponent Component to wrap with scroll position
 * @param {Object} options Additional options
 * @return {Function} Component with scroll position in props
 */
function withScrollPos(WrappedComponent, options = {}) {
  return class extends Component {
    state = {
      scrollPos: 0,
      thresholdTriggered: false,
    };

    handleScroll = () => {
      let lastScrollPos = 0;
      let ticking = false;

      lastScrollPos = window.scrollY || 0;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.setState({
            scrollPos: lastScrollPos,
            thresholdTriggered: this.state.thresholdTriggered
              ? this.state.thresholdTriggered
              : lastScrollPos >= options.threshold,
          });
          ticking = false;
        });

        ticking = true;
      }
    };

    componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
      return (
        <WrappedComponent
          scrollPos={this.state.scrollPos}
          thresholdTriggered={this.state.thresholdTriggered}
          {...this.props}
        />
      );
    }
  };
}

export default withScrollPos;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/WithScrollPos/index.js